var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_121028",
    "data-name": "Path 121028",
    d: "M4.937,10.142H16.056l-3.4-3.737A.809.809,0,0,1,12.775,5.2a1,1,0,0,1,1.322.111l4.688,5.142a1.006,1.006,0,0,1,.084.129c0,.043,0,.069.066.111a.758.758,0,0,1,0,.617c0,.043,0,.069-.066.111a1.006,1.006,0,0,1-.084.129L14.1,16.69a.975.975,0,0,1-.722.309.993.993,0,0,1-.6-.2.837.837,0,0,1-.335-.581.809.809,0,0,1,.213-.627l3.4-3.737H4.937a.861.861,0,1,1,0-1.714Z",
    transform: "translate(-4 -4.999)",
    fill: "#222d39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.fcb9e520065e7caad64c5c7a95843d18.svg";
export { ForwardRef as ReactComponent };